module.exports = __webpack_public_path__ + "img/DSC_0014.573eb294.jpg";